import React, { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";

import TextInputFormControl from "../../../shared/form-controls/TextInputFormControl";

function ColorPricingCategoryForm({ formData, submitForm }) {
  const history = useHistory();
  const { handleSubmit, control, reset } = useForm({
    defaultValues: useMemo(() => formData, [formData]),
  });

  useEffect(() => {
    reset(formData);
  }, [formData]);

  //======================================

  return (
    <form onSubmit={handleSubmit(submitForm)} className="w-100" noValidate>
      <div className="container" style={{ textAlign: "initial" }}>
        <div className="row justify-content-md-center">
          <div className="col-md">
            <Controller
              control={control}
              name="noColorIncluded"
              rules={{ required: true }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <TextInputFormControl
                  label="No Color Included"
                  placeholder="No Color Included"
                  required
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />

            <Controller
              control={control}
              name="noLocIncluded"
              rules={{ required: true }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <TextInputFormControl
                  label="No Location Included"
                  placeholder="No Location Included"
                  required
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />

            <Controller
              control={control}
              name="pricingType"
              rules={{ required: true }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <TextInputFormControl
                  label="Pricing Type"
                  placeholder="Pricing Type"
                  required
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />
          </div>
        </div>
      </div>
      <hr />
      <div className="d-flex justify-content-center">
        <span
          className="btn btn-sm btn-danger mr-5"
          onClick={(e) => history.goBack()}
        >
          Cancel
        </span>
        <button type="submit" className="btn btn-sm btn-success">
          Save
        </button>
      </div>
    </form>
  );
}

export default ColorPricingCategoryForm;
